// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-bottom-5[data-v-667f93e0]{margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
